import { apiSlice } from "../apiSlice";

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_DEV || process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;

export interface Customer {
  isAnonymousUser: boolean;
  id: string;
  documentId?: string;
  displayName: string;
  phoneNumber: string;
  email: string;
  createdAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  userId?: string;
  photoUrl?: string;
  updatedAt?: {
    _seconds: number;
    _nanoseconds: number;
  };
  addresses?: any[];
  firstName?: string;
  lastName?: string;
  birthDate?: string;
  settings?: {
    requiresOrderVerification?: boolean;
  };
}

export interface GetSearchRequest {
  hits: any;
  params: string;
}

interface walletBalanceResponse {
  walletBalance: number;
}

const ALGOLIA_APP_ID = process.env.REACT_APP_ALGOLIA_APP_ID;

const ALGOLIA_API_KEY = process.env.REACT_APP_ALGOLIA_API_KEY;

export const customerService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    topUpWallet: builder.mutation({
      query: (data) => ({
        url: `https://adminhttps-topupcustomerwalletbalance-${API_BASE_DOMAIN}-uc.a.run.app`,
        method: "POST",
        body: data,
      }),
    }),

    getCustomersList: builder.query<Customer[], void>({
      query: () => ({
        url: `https://adminhttps-getcustomerslist-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "GET",
      }),
    }),

    // New query to get customer by ID
    getCustomerById: builder.query<Customer, string>({
      query: (customerId) => ({
        url: `https://adminhttps-getcustomerbyid-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "GET",
        params: {
          customerId: customerId
        }
      }),
    }),
    getUserTypeWiseSearchResults: builder.mutation<GetSearchRequest, any>({
      query: (data) => ({
        url: `https://${ALGOLIA_APP_ID}-dsn.algolia.net/1/indexes/UserSearchDocuments/query`,
        method: "POST",
        body: data,
        headers: {
          "X-Algolia-Application-Id": `${ALGOLIA_APP_ID}`,
          "X-Algolia-API-Key": `${ALGOLIA_API_KEY}`,
        },
      }),
    }),
    getWalletBalance: builder.query<walletBalanceResponse, string>({
      query: (customerId) => ({
        url: `https://adminhttps-getcustomerwalletbalance-${API_BASE_DOMAIN}-uc.a.run.app?customerId=${customerId}`,
        method: "GET",
      }),
      keepUnusedDataFor: 180,
    }),
  })
});

export const {
  useTopUpWalletMutation,
  useLazyGetCustomersListQuery,
  useGetCustomerByIdQuery,
  useGetUserTypeWiseSearchResultsMutation,
  useGetWalletBalanceQuery,
} = customerService;